import { render, staticRenderFns } from "./ListRulesPoints.vue?vue&type=template&id=697ba5f4&"
import script from "./ListRulesPoints.vue?vue&type=script&lang=js&"
export * from "./ListRulesPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports